<template>
  <div
    class="modal fade"
    id="gstModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div
      class="modal-dialog"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h5
            class="modal-title"
            id="exampleModalLabel"
												data-test="vendorGstModalHead1"
          >
            Bank Account information
          </h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            @click.prevent="modalClose"
												data-test="vendorGstModalCloseBtn"
												id="vendorGstModalCloseBtn"
          >
            <span aria-hidden="true"
																		data-test="vendorGstModalCloseSpan"
																		id="vendorGstModalCloseSpan">
              &times;
            </span>
          </button>
        </div>

        <div class="modal-body">
          <!-- Modal Body -->
          <div class="row m-0">
            <div class="col-12">
              <vendor-gst-form
                :gstData="gstData"
                :isDisabled="isView"
                @bankDetailsSubmit="bankDetailsSubmit($event)"
              />
            </div>
          </div>
          <!-- Modal Body -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VendorGstForm from '@/components/pages/vendor/forms/VendorGstForm'

export default {
	name: 'vendor-gst-modal',
	components: {
		VendorGstForm
	},
	methods: {
		bankDetailsSubmit (bankDetails) {
			this.$emit('gstDataSubmit', bankDetails)
		},
		modalClose () {
			this.$emit('gstModalClose')
		}
	},
	props: {
		gstData: {},
		isView: {
			type: Boolean,
			default: false
		}
	}
}
</script>

<style scoped>
</style>
